const colors = {
  vip: '#de9391',
  insider: '#02b5d1'
}

function replaceTextNodes(findText, replaceHTML) {
  function traverseAndReplace(element) {
    if (element.nodeType === Node.TEXT_NODE) {
      const parentNode = element.parentNode;
      const textContent = element.nodeValue;

      if (textContent.includes(findText)) {
        const parts = textContent.split(findText);
        const fragment = document.createDocumentFragment();
        
        parts.forEach((part, index) => {
          if (index > 0) {
            const span = document.createElement('span');
            span.innerHTML = replaceHTML;
            fragment.appendChild(span);
          }
          fragment.appendChild(document.createTextNode(part));
        });

        parentNode.replaceChild(fragment, element);
      }
    } else {
      element.childNodes.forEach(traverseAndReplace);
    }
  }
  traverseAndReplace(document.body);
}

function initSwellBanner(customer_details, color, swellTier, spapi) {

  console.log('customer_details', customer_details)
  console.log('color', color)
  console.log('swellTier', swellTier)
  console.log('spapi', spapi)

  var banners = document.querySelectorAll('.swell-image-banner')

  var badges = document.querySelectorAll('.tier-badge, .swell-bg-banner');
  
  badges.forEach(badge => {
    var currentSrc = badge.getAttribute("src");
    var newSrc = currentSrc.replace("loading", swellTier.toLowerCase());
    badge.setAttribute("src", newSrc);

    var currentSrcset = badge.getAttribute("srcset");
    if (currentSrcset) {
      var newSrcset = currentSrcset.replace(/loading/g, swellTier.toLowerCase());
      badge.setAttribute("srcset", newSrcset);
    }
  });

  /* name */
  replaceTextNodes("//customer-name//", `<span style="color:${color};">Welcome ${window.customer.first_name}</span>`);
  
  /* User Tier in welcome message */
  if (swellTier) replaceTextNodes("//user-tier//", `<span style="color:${color};">${swellTier}</span>`);
  
  /* Points on left side - lets convert this to a dollar value */
  var dollarBalance = ((spapi.customer.adjusted_points_balance * spapi.variableRedemptionOption.discount_rate_cents) / 100).toFixed(2);

  var swellPoints = customer_details?.vipTierStats?.pointsEarned;
  if (swellPoints) replaceTextNodes("//swell-points//", `<span style="color:${color};">${window.currency.symbol + dollarBalance}</span>`);

  var rich_text_heading = document.querySelectorAll(".rich-text__heading");
  rich_text_heading.forEach(heading => {
    heading.style.color = color;
  });

  banners.forEach(banner => {
    banner.querySelector('.banner__content').classList.remove('hidden');
  });

}

function initProductAddOns(customer_details, color, swellTier, spapi){

  var products = document.querySelectorAll('.featured-product .card--variant');

  products.forEach(product => {
    var headings = product.querySelectorAll('.card__heading');
    var meals_number;

    headings.forEach(heading => {
      var words = heading.innerText.trim();
      var new_words = words.replace('meals', 'cuddle+kind dollars')
      heading.innerText = new_words;
      meals_number = new_words
    });
    
    var modal_opener = product.querySelector('modal-opener');

    if(modal_opener){
      var modal = document.getElementById(modal_opener.dataset.id);

      if(modal){
        let points_balance = spapi.customer.adjusted_points_balance;
        let dollarBalance = (spapi.customer.adjusted_points_balance * spapi.variableRedemptionOption.discount_rate_cents)/100;
        let cost = parseInt(meals_number.replace(' cuddle+kind dollars', ''));

        if(dollarBalance >= cost){
          modal.querySelector('.dynamic-modal-text').innerHTML = `<h3 class="m-0">Are you sure?</h3><p>You currently have ${window.currency.symbol + dollarBalance} available. <br>This costs ${meals_number} to redeem.</p>`
        } else {
          modal.querySelector('.dynamic-modal-text').innerHTML = `<h3 class="m-0">We're sorry</h3><p>Looks like you don't have enough dollars for this product. This product costs ${meals_number} and you only have ${window.currency.symbol + dollarBalance} available.</p>`;
          modal.querySelector('.quick-add__submit').remove();
        }
      }
    }

  })

}

(function () {
  $(document).ready(function () {
    $(document).on("swell:setup", function() {

      var customer_details = Swell.Customer.getCustomerDetails();

      var swellTier = customer_details?.vipTier?.name ? customer_details?.vipTier?.name : 'insider';
      var color = colors[swellTier.toLowerCase()];

      // Init Points Banner
      if(swellTier){
        initSwellBanner(customer_details, color, swellTier, spapi);
        initProductAddOns(customer_details, color, swellTier, spapi)
      }

      Swell.Campaign.initializeCampaigns(".swell-campaign-list-left .swell-campaign-list", SwellConfig.Campaign.opts);
      SwellConfig.Campaign.appendCampaigns();
      SwellConfig.Campaign.authenticate();
      SwellConfig.Campaign.calculateDollarBalance();
      Swell.Redemption.initializeProductRedemptions(".swell-redemption-list", SwellConfig.Redemption.opts);
      spapi.setupBuyProductWithPointsHelper();
      SwellConfig.Referral.initializeReferral(".swell-referral");
      SwellConfig.Referral.populateReferrals();
      SwellConfig.Redemption.initializeSlider();
      SwellConfig.Tier.initializeDummyTier();
      SwellConfig.Tier.initializeCustomTierProperties();
      SwellConfig.Tier.initializeTiers(".swell-tier-table");
      // SwellConfig.Tier.initializeTierSlider();

      $(".swell-referral-loader").hide();
      $(".swell-checkout-dollar-balance-2").prepend("<span class='swell-dollar'>$</span>");
      $(".swell-checkout-dollar-balance-1 .swell-dollar").detach();
      $(".swell-redemption-list .swell-redemption:first-child").addClass("swell-active");
      $(".swell-redemption-list .swell-redemption:first-child").css("border", "solid 0.5px #949494");

      $('body').on('click', '.referral', function () {
        $(".swell-referral").css("display", "none");
        $(".referral-sidebar-content-outer-holder").css("display", "flex");
        $(".referral").addClass("active");
        $(".refer-friend-btn").removeClass("active");
      });

      $('body').on('click', '.refer-friend-btn', function () {
        $(".referral-sidebar-content-outer-holder").css("display", "none");
        $(".swell-referral").css("display", "block");
        $(".refer-friend-btn").addClass("active");
        $(".referral").removeClass("active");
      });

      $(".swell-redemption-list .swell-redemption").on("click", function() {
        $(".swell-redemption").removeClass("swell-active");
        $(".swell-redemption").css("border", "0");
        $(this).addClass("swell-active");
        $(this).css("border", "solid 0.5px #949494");
        let variantId = $(this).data("variant-id");
        $('.swell-add-to-cart').attr("style", "display: none !important");
        $('.swell-add-to-cart[data-variant-id="'+variantId+'"]').attr("style", "display: inline-block !important");
      });

      $('.swell-add-to-cart').attr("style", "display: none !important");
      $('.swell-buy-product-btn-first').attr("style", "display: inline-block !important");


      $(".swell-add-to-cart").on("click", function() {
        let variant_id = $(this).data("variant-id");
        swellAPI.refreshCustomerDetails(function() {
          let points_balance = spapi.customer.adjusted_points_balance;
          let dollarBalance = (spapi.customer.adjusted_points_balance * spapi.variableRedemptionOption.discount_rate_cents)/100;

          let redemptionCostInDollars;
          let redemptionOptions = spapi.activeRedemptionOptions;
          redemptionOptions.forEach(function(redemptionOption) {
            if(redemptionOption.applies_to_id == variant_id) {
              redemptionCostInDollars = (redemptionOption.amount * spapi.variableRedemptionOption.discount_rate_cents)/100;
              if(points_balance >= redemptionOption.amount) {
                setTimeout(function() {
                  $(".jconfirm-content").html("You currently have $"+dollarBalance+" available. This costs $"+redemptionCostInDollars+" to redeem.");
                  // $(".jconfirm").css("display", "block");
                }, 500);
              } else {
                setTimeout(function() {
                  $(".jconfirm-content").html("Looks like you don\'t have enough dollars for this product. This product costs $"+redemptionCostInDollars+" and you only have $"+dollarBalance+" available.");
                  // $(".jconfirm").css("display", "block");
                }, 500);
              }
            }
          });
        });
      });

      $('body').on("click", ".swell-refer-friends", function() {
        if($(".swell-referral-form-list-email").length < 6) {
          $(".swell-referral-form-list .input-holder-append").append(`
            <div class="grid__item">
              <div class="field">
                <input class="swell-referral-form-list-email" name="swell-referral-form-list-input[]" type="email" placeholder="friend@mail.com">
                <label for="RegisterForm-email">friend@mail.com</label>
              </div>
            </div>
            <div class="grid__item">
              <div class="field">
                <input class="swell-referral-form-list-email" name="swell-referral-form-list-input[]" type="email" placeholder="friend@mail.com">
                <label for="RegisterForm-email">friend@mail.com</label>
              </div>
            </div>
          `);
          if($(".swell-referral-form-list-email").length == 6) {
            $(".swell-refer-friends").detach();
          }
        }
      });

      $(window).resize(function() {
        if($(window).width()< 768) {
          SwellConfig.Redemption.initializeSlider();
          $(".swell-redemption").removeClass("swell-active");
          $(".swell-redemption").css("border", "0");
          // $(".swell-redemption-list").slick('refresh');
        }
        else {
          // $('.swell-redemption-list').slick('unslick');
        }
      });

      $(".swell-referral-loader").hide();
      // $(".swell-redemption-list").slick('refresh');

      // $('.swell-redemption-list').on('afterChange', function(event, slick, currentSlide, nextSlide){
      //   $('.swell-add-to-cart').attr("style", "display: none !important");
      //   $('.swell-add-to-cart').eq(currentSlide).attr("style", "display: inline-block !important");
      // });

    });

    var myVar;
    $(document).on("click", "#swell-referral-register-submit", function() {
      myVar = setInterval(timer, 200);
    });

    function timer() {
      if($("#swell-refer-heading").length==1) {
        $([document.documentElement, document.body]).animate({
          scrollTop: $("#swell-refer-heading").offset().top - 150
        }, 2000);
        stop();
      }
    }

    function stop() {
      clearInterval(myVar);
    }

    $(document).on("click", ".swell-send-email", (evt) => {
      evt.preventDefault();

      var values = "";
      var counter = 0;
      $("input[name='swell-referral-form-list-input[]']").each(function() {
        console.log(this)
        if($(this).val() != "") {
          if(counter == 0) {
            values = values + $(this).val();
          } else {
            values = values + "," + $(this).val();
          }
        }
        counter++;
      });

      console.log('values', values);

      $(".swell-referral-form-list-field-input").val(values);
      $(".swell-referral-form-list-submit").click();

      // $('.scroller').animate({
      //     scrollTop: $("#refer-confirmation").offset().top
      // }, 2000);

    });

    $(document).on("click", ".swell-post-checkout .swell-referral-back-link", function() {
      $(".swell-post-checkout").hide();
    });

    $(document).on("swell:referral:success", function () {

      swellAPI.refreshCustomerDetails(function () {
        $(".table-data").html("");
        SwellConfig.Referral.populateReferrals();
      });
    });

    $(document).on("swell:referral:error", function (jqXHR, textStatus, errorThrown) {

      if (textStatus && textStatus === "EMAILS_ALREADY_PURCHASED") {
        $(".refer-customer-error").remove();
        $(".swell-refer-friends").after('<p class="refer-customer-error">Sorry! Looks like this person has already made a purchase. Try referring another friend.</p>');
      }

      if (textStatus && textStatus === "Please enter a valid email address") {
        $(".refer-customer-error").remove();
        $(".swell-refer-friends").after('<p class="refer-customer-error">Please enter valid email addresses seperated with commas</p>');
      }
    });
  });
}).call(this);

(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Campaign = {
    opts: {
      templates: {
        campaign: "<li class='swell-campaign'> <div class='swell-campaign-content' data-display-mode='modal' data-campaign-id='<%= campaign.id %>'> <i class='swell-campaign-icon <%= campaign.icon %>'><span class='path1'></span><span class='path2'></span><span class='path3'></span><span class='path4'></span><span class='path5'></span><span class='path6'></span><span class='path7'></span><span class='path8'></span><span class='path9'></span></i> <p class='swell-campaign-text swell-text m-0'><%= campaign.title %></p> </div> </li>"
        //campaign: "<li class='swell-campaign'> <div class='swell-campaign-content' data-display-mode='modal' data-campaign-id='<%= campaign.id %>'> <i class='swell-campaign-icon <%= campaign.icon %>'><span class='path1'></span><span class='path2'></span><span class='path3'></span><span class='path4'></span><span class='path5'></span><span class='path6'></span><span class='path7'></span><span class='path8'></span><span class='path9'></span></i> <p class='swell-campaign-text swell-text m-0'><%= campaign.title %></p> </div> </li>"
        // campaignHover: '<div class="swell-campaign-hover"> <div class="swell-campaign-hover-content"> <ul class="swell-link-list"> <li class="swell-link"> <a href="/account/login?return_url=/pages/rewards" class="swell-link-login">SIGN IN</a> </li> <li class="swell-link"> <a href="/account/register" class="swell-link-register">SIGN UP</a> </li> </ul> </div> </div>'
      }
    },
    appendCampaigns: function() {
      $(".swell-campaign-list-left .swell-campaign-list").append(`
        <li class="swell-campaign">
          <div class="swell-campaign-content">
            <i class="swell-campaign-icon swell-icon-Every-Purchase"></i>
            <p class="swell-campaign-text swell-text m-0">For every $1 spent</p>
          </div>
        </li>
        <li class="swell-campaign">
          <div class="swell-campaign-content">
            <i class="swell-campaign-icon swell-icon-Birthday-Bonus"></i>
            <p class="swell-campaign-text swell-text m-0">Happy Birthday</p>
          </div>
        </li>
        <li class="swell-campaign">
          <div class="swell-campaign-content">
            <i class="swell-campaign-icon swell-icon-Exclusive-savings"></i>
            <p class="swell-campaign-text swell-text m-0">Exclusive savings events</p>
          </div>
        </li>
        <li class="swell-campaign">
          <div class="swell-campaign-content">
            <i class="swell-campaign-icon swell-icon-Rewards-Events"></i>
            <p class="swell-campaign-text swell-text">2x Rewards Events</p>
          </div>
        </li>
        <li class="swell-campaign">
          <div class="swell-campaign-content">
            <i class="swell-campaign-icon swell-icon-Customer-Appreciation-Event"></i>
            <p class="swell-campaign-text swell-text">Customer Appreciation Event</p>
          </div>
        </li>
        `);
    },
    authenticate: function() {
      spapi.$(document).off("click", ".swell-campaign-content");
      return $(".swell-campaign-content").hover(function() {
        return $(this).append(SwellConfig.Campaign.opts.templates.campaignHover);
      }, function() {
        return $(this).find(".swell-campaign-hover").remove();
      });
    },
    calculateDollarBalance: function() {
      let dollarBalance = 0;
      dollarBalance = ((spapi.customer.adjusted_points_balance * spapi.variableRedemptionOption.discount_rate_cents)/100).toFixed(2);
      $(".swell-checkout-dollar-balance-2").append(dollarBalance);
    }
  };

}).call(this);

(function () {
  window.SwellConfig = window.SwellConfig || {};
  SwellConfig.Tier = {
      getCustomerTierId: function () {
          var customer_tier, intro_tier, tiers;
          customer_tier = spapi.customer.vip_tier;
          tiers = spapi.activeVipTiers;
          if (customer_tier) {
              return customer_tier.id;
          } else {
              intro_tier = $.grep(tiers, function (e) {
                  return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
              });
              if (intro_tier.length > 0) {
                  return intro_tier[0].id;
              } else {
                  return null;
              }
          }
      },
      getCustomerTierRank: function () {
          var customer_tier, intro_tier, rank, tiers;
          customer_tier = spapi.customer.vip_tier;
          tiers = spapi.activeVipTiers;
          if (customer_tier && customer_tier.id) {
              rank = $.grep(tiers, function (e) {
                  return e.id === customer_tier.id;
              })[0].rank;
              return rank;
          } else {
              intro_tier = $.grep(tiers, function (e) {
                  return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
              });
              if (intro_tier.length > 0) {
                  return intro_tier[0].rank;
              } else {
                  return null;
              }
          }
      },
      getTierByRank: function (rank) {
        var tiers;
        tiers = spapi.activeVipTiers;
        return $.grep(tiers, function (e) {
            return e.rank === rank;
        })[0];
      },
      setupCustomerTierStatus: function() {
        let spend_required, next_tier, customer_tier_id;
        customer_tier_id = SwellConfig.Tier.getCustomerTierId();

        var vip_name = spapi.customer.vip_tier.name;

        if(vip_name === 'VIP'){
          $('.swell-img-insider').addClass('d-none');
          $('.swell-img-vip').removeClass('d-none');
        } else {
          $('.swell-img-insider').removeClass('d-none');
          $('.swell-img-vip').addClass('d-none');
        }

        if(spapi.customer.vip_tier) {

          $(".swell-cuddle-kind").addClass('swell-tier-' + vip_name.toLowerCase().replace(/ /g,'-'))

          $(".swell-vip-tier-name").html(vip_name);
          $(".swell-vip-tier-name").addClass(vip_name.toLowerCase().replace(/ /g,'-'))
         // $(".swell-tier-list.swell-insider").detach();
          $(".swell-cuddle-kind .vip-table-section .swell-tier-table .swell-tier-table-header").css("flex", "1.5");
          $(".swell-cuddle-kind .vip-table-section .swell-tier-table").css("align-items", "flex-end");

          // if(vip_name == 'VIP'){
          //   $('.swell-tier-list.swell-insider').hide();
          //   $(".swell-logged-in-banner").addClass("swell-vip-status");
          //   $(".swell-checkout-dollar-balance-2").css("color", "rgb(224, 126, 57)");
          // } else {
          //   $('.swell-tier-list.swell-vip').hide();
          // }

        } else {
          let customer_tier_rank = SwellConfig.Tier.getCustomerTierRank();
          if(customer_tier_rank != null) {
            next_tier = SwellConfig.Tier.getTierByRank(customer_tier_rank + 1);
          } else {
            next_tier = SwellConfig.Tier.getTierByRank(0);
          }

          $(".swell-cuddle-kind").addClass('swell-tier-insider');

          $(".swell-vip-img").detach();
          $(".swell-vip-tier-name").html("Insider");
          spend_required = ((next_tier.points_earned - swellAPI.getCustomerDetails().pointsEarned)/5);
          if(spend_required < 0) {
            spend_required = 0;
          }
          $(".swell-tier-spend").html(spend_required);
        }

        let customer_tier = spapi.customer.vip_tier;

        // $(".swell-tier-list.swell-insider[data-tier-id='10640']").remove();
        //
        //
        // if (customer_tier.id !== 4036) {
        //
        //  $(".swell-cuddle-kind .swell-logged-in-banner.swell-vip-status").removeClass('swell-vip-status');
        //  $(".swell-tier-list.swell-vip").remove();
        //
        // } else {
        //
        //  $(".swell-tier-list.swell-vip").detach();
        //   $(".swell-tier-list.swell-insider").remove();
        //   $(".swell-checkout-dollar-balance-2").css("color", "rgb(224, 126, 57)");
        //
        // }
        // let customer_tier_rank = SwellConfig.Tier.getCustomerTierRank();
        // if(customer_tier_rank != null) {
        //   next_tier = SwellConfig.Tier.getTierByRank(customer_tier_rank + 1);
        // } else {
        //   next_tier = SwellConfig.Tier.getTierByRank(0);
        // }

        // if(customer_tier_rank != (spapi.activeVipTiers.length - 1)) {
        //   spend_required = (next_tier.points_earned - swellAPI.getCustomerDetails().pointsEarned);

        //   if(spend_required < 0) {
        //     spend_required = 0;
        //   }
        //   $(".swell-tier-spend").html(spend_required);
        // }
      },
      initializeDummyTier: function() {
          var k, len, tier, tiers;
          tiers = spapi.activeVipTiers;
          for (k = 0, len = tiers.length; k < len; k++) {
              tier = tiers[k];
              tier.rank += 1;
          }
          return tiers.unshift({
              id: -1,
              rank: 0,
              name: "Create an Account",
              point_multiplier: "1x",
              swellrequiredAmountSpent: "$0",
              swellrequiredAmountSpentCents: 0,
              swellrequiredPointsEarned: 0,
              swellrequiredPurchasesMade: 0,
              swellrequiredReferralsCompleted: 0
          });
      },
      initializeCustomTierProperties: function () {
        spapi.activeVipTiers[0].spendPoints = "Free to join",
        spapi.activeVipTiers[0].name = "Insider",
        spapi.activeVipTiers[0].benefit1 = "5% back",
        spapi.activeVipTiers[0].benefit2 = "<span class='swell-icon-VIP-Heart-1'></span>",
        spapi.activeVipTiers[0].benefit3 = "<span class='swell-icon-VIP-Heart-1'></span>",
        spapi.activeVipTiers[0].benefit4 = "<span class='swell-icon-VIP-Heart-1'></span>",
        spapi.activeVipTiers[0].benefit5 = "<span class='swell-icon-VIP-Heart-1'></span>",
        spapi.activeVipTiers[0].benefit6 = "Earn 10% back",
        spapi.activeVipTiers[0].benefit7 = "<span class='swell-icon-VIP-Heart-1'></span>",
        spapi.activeVipTiers[0].benefit8 = "<span class='swell-icon-VIP-Heart-1'></span>",
       spapi.activeVipTiers[0].benefit9 = "<span class='swell-icon-VIP-Heart-1'></span>",
        spapi.activeVipTiers[0].benefit10 = "",

        // spapi.activeVipTiers[1].spendPoints = "$"+(spapi.activeVipTiers[1].points_earned * spapi.variableRedemptionOption.discount_rate_cents / 100)+" lifetime spend",
        // spapi.activeVipTiers[1].spendPoints = "Upto "+(spapi.activeVipTiers[1].points_earned)+" Points Earned",
        spapi.activeVipTiers[1].spendPoints = "$500 Lifetime Spend",
        spapi.activeVipTiers[1].name = "VIP",
        spapi.activeVipTiers[1].benefit1 = "10% back",
        spapi.activeVipTiers[1].benefit2 = "<span class='swell-icon-VIP-Heart-2'></span>",
        spapi.activeVipTiers[1].benefit3 = "<span class='swell-icon-VIP-Heart-2'></span>",
        spapi.activeVipTiers[1].benefit4 = "<span class='swell-icon-VIP-Heart-2'></span>",
        spapi.activeVipTiers[1].benefit5 = "<span class='swell-icon-VIP-Heart-2'></span>",
        spapi.activeVipTiers[1].benefit6 = "Earn 20% back",
        spapi.activeVipTiers[1].benefit7 = "<span class='swell-icon-VIP-Heart-2'></span>",
        spapi.activeVipTiers[1].benefit8 = "<span class='swell-icon-VIP-Heart-2'></span>",
        spapi.activeVipTiers[1].benefit9 = "<span class='swell-icon-VIP-Heart-2'></span>",
        spapi.activeVipTiers[1].benefit10 = "<span class='swell-icon-VIP-Heart-2'></span>"
      },
      initializeTiers: function(containerSelector) {
        tiers = spapi.activeVipTiers;
        var counter = 0, tier_name;
      $(".swell-tier-table .swell-tier-table-header").append('<li class="swell-tier-list"><div class="swell-tier-spend-1 tier-list">Rewards</div><div class="tier-list swell-text">Earn cuddle+kind dollars</div> <div class="tier-list swell-text">Earn credit for past purchases*</div> <div class="tier-list swell-text">Earn $10 for signing up + give 10 meals to children in need</div> <div class="tier-list swell-text">Get 15% off on your birthday</div><div class="tier-list swell-text">Exclusive seasonal savings events</div><div class="tier-list swell-text">Exclusive 2X Reward Events</div><div class="tier-list swell-text">Exclusive Annual Appreciation Event</div><div class="tier-list swell-text">Choose to donate your cuddle+kind dollars to feed children</div><div class="tier-list swell-text">Early access to sale events</div><div class="tier-list swell-text">Free Shipping on all orders within the US and Canada</div></li>');
        tiers.forEach(function (tier) {
          if(counter==0) {
              tier_name = "insider";
          } else if(counter==1) {
              tier_name = "vip";
          }
          $(".swell-tier-table-body").append('<li class="swell-tier-list swell-'+tier_name+'" data-tier-id="'+tier.id+'"><div class="swell-tier-spend-1 tier-list"><span class="swell-tier-name">'+tier.name+'</span>'+tier.spendPoints+'</div><div class="tier-list tier-multiplier"><div class="tier-list-insider">'+tier.benefit1+'</div></div></div> <div class="tier-list"><div class="tier-list-insider">'+tier.benefit2+'</div></div> <div class="tier-list"><div class="tier-list-insider">'+tier.benefit3+'</div></div> <div class="tier-list"><div class="tier-list-insider">'+tier.benefit4+'</div></div> <div class="tier-list"><div class="tier-list-insider">'+tier.benefit5+'</div></div> <div class="tier-list"><div class="tier-list-insider">'+tier.benefit6+'</div></div> <div class="tier-list"><div class="tier-list-insider">'+tier.benefit7+'</div></div> <div class="tier-list"><div class="tier-list-insider">'+tier.benefit8+'</div></div> <div class="tier-list"><div class="tier-list-insider">'+tier.benefit9+'</div></div> <div class="tier-list"><div class="tier-list-insider">'+tier.benefit10+'</div></div></li>');
          counter++;
        });

        if(spapi.authenticated) {
          SwellConfig.Tier.setupCustomerTierStatus();
        }
      },
      initializeTierSlider: function() {
        if(!spapi.customer.vip_tier) {
          // $(".swell-tier-table-body").slick({
          //     dots: false,
          //     arrows:true,
          //     nextArrow: '<div class="icon-holder right-arrow"><i class="swell-icon-chevron-thin-right slick-arrows"></i></div>',
          //     prevArrow: '<div class="icon-holder left-arrow"><i class="swell-icon-chevron-thin-left slick-arrows"></i></div>',
          //     infinite: true,
          //     speed: 300,
          //     slidesToScroll:2,
          //     slidesToShow: 2,
          //     responsive: [
          //       {
          //         breakpoint: 769,
          //         settings: {
          //           dots: true,
          //           slidesToShow: 1,
          //           slidesToScroll: 1,
          //         }
          //       }
          //     ]
          // });
        }
      }
  };
}).call(this);

(function() {
window.SwellConfig = window.SwellConfig || {};

SwellConfig.Redemption = {
  opts: {
    templates: {
      redemptionOptionProduct: '<div class="swell-redemption" data-variant-id="<%= redemption.applies_to_id %>"> <img src="<%= redemption.background_image_url %>" }}"> <div class="swell-redeem-content"><p class="swell-price swell-text"> <%= redemption.cost_text %> </p></div> </div>'
    }
  },
  initializeSlider: function() {
    if($(window).width()< 768) {
      // $(".swell-redemption-list").slick({
      //   dots: false,
      //   infinite: true,
      //   speed: 300,
      //   slidesToScroll:1,
      //   slidesToShow: 1,
      //   nextArrow: '<img class="swell-arrow" src="https://cdn.shopify.com/s/files/1/0030/8376/3824/t/20/assets/swell-angle-right.svg?v=5087289026892207704">',
      //   prevArrow: '<img class="swell-arrow" src="https://cdn.shopify.com/s/files/1/0030/8376/3824/t/20/assets/swell-angle-left.svg?v=8317739586176780282">',
      //   responsive: [
      //   {
      //     breakpoint: 768,
      //     settings: {
      //       slidesToShow: 1,
      //       slidesToScroll: 1,
      //     }
      //   }
      //   ]
      // });
    }
  },
  initializeProducts: function() {
    if(spapi.authenticated) {
      spapi.setupBuyProductWithPointsHelper();
    }
  }
};
}).call(this);

(function () {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Referral = {
      opts: {
        localization: {
          referralRegisterHeading: "Give 20%, Get $20.",
          referralRegisterFormDetails: "Please enter your email below to get started.",
          referralReferHeading: "Give 20%, Get $20.",
          referralThanksHeading: "Thanks for Referring.",
          referralReferMediaDetails: "You can also share your link with the buttons below.",
          referralReferFormDetails: "Please enter your friends’ email addresses.",
          referralReferFormEmailsDetails: "",
          referralRegisterFormEmail: "Email address",
          referralReferFormEmails: "friend@mail.com",
          referralRegisterFormEmail: "Email address",
          referralRegisterFormSubmit: "Next",
          referralReferFormSubmit: "Next",
          referralCopyButton: "COPY LINK",
          referralCopyDetails: "Copy link and share with your friends."
        },
        templates: {
          referralRegister: `
          
          <div class="swell-referral-register">
            <h2>REFER A FRIEND - STEP ONE</h2>
            <h2 class="swell-referral-heading mb-0 py-3"><%= localization.referralRegisterHeading %></h2>
          </div>
          <div class="swell-referral-form-wrapper">
            <form name="swell-referral-register-form" id="swell-referral-register-form" method="POST" action=".">
              <div class="swell-referral-form-header">
                <p class="swell-referral-form-header-details"><%= localization.referralRegisterFormDetails%></p>
              </div>
              <div class="swell-referral-form-body">
                <ul class="swell-referral-form-list list-unstyled">
                  <li class="swell-referral-form-list-field mb-4 customer referral-widget">
                    <div style="max-width:550px; margin:0 auto;" class="mb-3">
                      <div class="field">
                        <input type="email" class="swell-referral-form-list-email" name="swell-referral-register-email" id="swell-referral-register-email" required="required" placeholder="Email Address">
                        <label for="RegisterForm-email">Email Address</label>
                      </div>
                    </div>
                  </li>
                  <li class="swell-referral-form-list-field mb-5">
                    <input class="swell-referral-form-list-submit button button--primary" type="submit" name="swell-referral-register-submit" id="swell-referral-register-submit" value="<%= localization.referralRegisterFormSubmit %>">
                  </li>
                </ul>
              </div>
            </form>
          </div>
          `,
          referralRefer: `
          <div id="refer-a-friend-step-2">
            <div class="swell-referral-refer mt-5 mb-4" id="swell-refer-heading">
              
              <h2 class="swell-referral-heading h1">
                <span class="h3 m-0">REFER A FRIEND - STEP ONE</span>
                <span class="d-block mb-3"><%= localization.referralReferHeading %> </span>
              </h2>
              <button class="swell-send-mesg-text swell-text swell-share-referral-sms swell-mobile text-primary small button button--primary">Refer by Text</button>
            </div>
            <div class="swell-referral-form-wrapper px-4">
              <form class="swell-referral-form" name="swell-referral-refer-form" id="swell-referral-refer-form" method="POST" action=".">
                <div class="swell-referral-form-header">
                  <p class="swell-referral-form-header-details"><%= localization.referralReferFormDetails%></p>
                </div>
                <div class="swell-referral-form-body">
                  <ul class="swell-referral-form-list list-unstyled customer swell-referral-form-wrapper swell-referral-form-list-field">
                    <li class="swell-referral-form-list-field grid grid grid--1-col grid--2-col-desktop input-holder-append">
                      <div class="grid__item">
                        <div class="field">
                          <input class="swell-referral-form-list-field-input" required="required" type="text" name="swell-referral-form-list-input[]" id="swell-referral-refer-emails" swellrequired="swellrequired" placeholder="<%= localization.referralReferFormEmails %>">
                          <label for="RegisterForm-email"><%= localization.referralReferFormEmails %></label>
                        </div>
                      </div>
                      <div class="grid__item">
                        <div class="field">
                          <input class="swell-referral-form-list-email" type="email" name="swell-referral-form-list-input[]" placeholder="<%= localization.referralReferFormEmails %>">
                          <label for="RegisterForm-email"><%= localization.referralReferFormEmails %></label>
                        </div>
                      </div>
                      <div class="grid__item">
                        <div class="field">
                          <input class="swell-referral-form-list-email" type="email" name="swell-referral-form-list-input[]" placeholder="<%= localization.referralReferFormEmails %>">
                          <label for="RegisterForm-email"><%= localization.referralReferFormEmails %></label>
                        </div>
                      </div>
                      <div class="grid__item">
                        <div class="field">
                          <input class="swell-referral-form-list-email" type="email" name="swell-referral-form-list-input[]" placeholder="<%= localization.referralReferFormEmails %>">
                          <label for="RegisterForm-email"><%= localization.referralReferFormEmails %></label>
                        </div>
                      </div>
                    </li>

                    <button class="swell-refer-friends m-0 swell-text button button--secondary">
                      
                      <svg
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                      focusable="false"
                      class="icon icon-plus"
                      fill="none"
                      viewBox="0 0 10 10"
                    >
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor">
                    </svg>
                  
                      <span>refer more friends</span>
                    </button>

                    <li class="swell-referral-form-list-field">
                      <input class="swell-referral-form-list-submit button button--primary mx-2" type="submit" name="swell-referral-refer-submit" id="swell-referral-refer-submit" value="<%= localization.referralReferFormSubmit %>">
                      <button class="swell-send-email swell-text button button--primary mx-2 mb-0">Send Email</button>
                    </li>

                  </ul>
                </div>
              </form>
            </div>
            </div>
          <div class="swell-referral-media-wrapper py-5">
            <p class="swell-referral-media-details swell-text"><%= localization.referralReferMediaDetails %></p>
            <ul class="swell-referral-media-list list-unstyled text-center">
              <li class="swell-referral-medium swell-share-referral-sms swell-mobile d-inline-block mx-2">
                <div class="swell-referral-medium-content"> 
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M7.75 13.75a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.75-.75Z"/><path fill-rule="evenodd" d="M4.75 5.75a2.75 2.75 0 0 1 2.75-2.75h5a2.75 2.75 0 0 1 2.75 2.75v8.5a2.75 2.75 0 0 1-2.75 2.75h-5a2.75 2.75 0 0 1-2.75-2.75v-8.5Zm2.75-1.25c-.69 0-1.25.56-1.25 1.25v8.5c0 .69.56 1.25 1.25 1.25h5c.69 0 1.25-.56 1.25-1.25v-8.5c0-.69-.56-1.25-1.25-1.25h-.531a1 1 0 0 1-.969.75h-2a1 1 0 0 1-.969-.75h-.531Z"/></svg>
                  Text 
                </div>
              </li>
              <li class="swell-referral-medium swell-share-referral-messenger d-inline-block mx-2">
                <div class="swell-referral-medium-content"> 
                  <svg aria-hidden="true" focusable="false" class="icon icon-facebook" viewBox="0 0 20 20">
                    <path fill="currentColor" d="M18 10.049C18 5.603 14.419 2 10 2c-4.419 0-8 3.603-8 8.049C2 14.067 4.925 17.396 8.75 18v-5.624H6.719v-2.328h2.03V8.275c0-2.017 1.195-3.132 3.023-3.132.874 0 1.79.158 1.79.158v1.98h-1.009c-.994 0-1.303.621-1.303 1.258v1.51h2.219l-.355 2.326H11.25V18c3.825-.604 6.75-3.933 6.75-7.951Z"/>
                  </svg>
                  Messenger
                </div>
              </li>
              <li class="swell-referral-medium swell-share-referral-twitter d-inline-block mx-2">
                <div class="swell-referral-medium-content"> 
                  <svg aria-hidden="true" focusable="false" class="icon icon-twitter" viewBox="0 0 20 20">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.27274 2.8L10.8009 7.82176L15.2183 2.8H16.986L11.5861 8.93887L17.3849 17.1928H12.7272L8.99645 11.8828L4.32555 17.1928H2.55769L8.21157 10.7657L2.61506 2.8H7.27274ZM13.5151 15.9248L5.06895 4.10931H6.4743L14.9204 15.9248H13.5151Z" fill="currentColor"/>
                  </svg>
                  Twitter 
                </div>
              </li>
              <li class="swell-referral-medium swell-share-referral-copy d-inline-block mx-2">
                <div class="swell-referral-medium-content"> 
                <svg
                  width="13"
                  height="12"
                  viewBox="0 0 13 12"
                  class="icon icon-share"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  focusable="false"
                >
                  <path d="M1.625 8.125V10.2917C1.625 10.579 1.73914 10.8545 1.9423 11.0577C2.14547 11.2609 2.42102 11.375 2.70833 11.375H10.2917C10.579 11.375 10.8545 11.2609 11.0577 11.0577C11.2609 10.8545 11.375 10.579 11.375 10.2917V8.125" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M6.14775 1.27137C6.34301 1.0761 6.65959 1.0761 6.85485 1.27137L9.56319 3.9797C9.75845 4.17496 9.75845 4.49154 9.56319 4.6868C9.36793 4.88207 9.05135 4.88207 8.85609 4.6868L6.5013 2.33203L4.14652 4.6868C3.95126 4.88207 3.63468 4.88207 3.43942 4.6868C3.24415 4.49154 3.24415 4.17496 3.43942 3.9797L6.14775 1.27137Z" fill="currentColor"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M6.5 1.125C6.77614 1.125 7 1.34886 7 1.625V8.125C7 8.40114 6.77614 8.625 6.5 8.625C6.22386 8.625 6 8.40114 6 8.125V1.625C6 1.34886 6.22386 1.125 6.5 1.125Z" fill="currentColor"/>
                </svg>
                Share link</div>
              </li>
            </ul>
          </div>
          </div>
          `,
          referralThanks: `
          <div class="swell-referral-thanks my-4">
            <span class="swell-referral-back-link"></span>
            <h2 id="refer-confirmation" class="swell-referral-heading">
              <%= localization.referralThanksHeading %>
            </h2>
            <p class="swell-referral-details">Remind your friends to check their email.</p>
          </div>
          <script>
            $(".swell-referral-thanks").click(function() {
              $(this).css('display', 'none');
            });
          </script>
          `
        }
      },
      initializeReferral: function (containerSelector) {
          var email = $(containerSelector).data("customer-email");
          if (email) {
              spapi.storage.setItem("referrer_email", email);
              spapi.customer.email = email;
          }
          Swell.Referral.initializeReferral(".swell-referral", SwellConfig.Referral.opts);
      },
      populateReferrals: function () {
          if (spapi.authenticated) {
              var referral_receipts = spapi.customer.referral_receipts;
              referral_receipts.forEach(function (referral_receipt) {
                  var email = referral_receipt.email;
                  var completed_at = referral_receipt.completed_at;
                  if (completed_at) {
                    status = "completed";
                    $(".table-data").append("<tr class='swell-table-row swell-completed'><td class='swell-td swell-truncate'>" + email + "</td><td class='swell-td'>" + status + "</td></tr>");
                  } else {
                    status = "pending";
                    $(".table-data").append("<tr class='swell-table-row'><td class='swell-td swell-truncate'>" + email + "</td><td class='swell-td'>" + status + "</td></tr>");
                  }
              });
          }
      }
  };
}).call(this);
